import { Button, Heading } from '@apollo/orbit';
import { Telescope } from '@apollo/space-kit/illustrations/Telescope';
import React from 'react';

import { NoData } from 'src/components/common/noData/NoData';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

import { ErrorsView } from './sharedTypes';

export function NoGraphQLErrors({
  hasOnlyOperationStatsData,
  onViewChange,
}: {
  hasOnlyOperationStatsData: boolean;
  onViewChange: (view: ErrorsView) => void;
}) {
  const trackCustomEvent = useTrackCustomEvent();
  const handleViewChange = () => {
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'errors_view_change',
      label: 'requests_from_no_graphql_errors',
    });
    onViewChange('requests');
  };

  return (
    <NoData
      className="flex h-80 items-center justify-center"
      message={
        <>
          <Heading size="lg">
            {hasOnlyOperationStatsData
              ? 'No GraphQL error data'
              : 'No errors reported'}
          </Heading>
          <Telescope className="my-2" />
          {hasOnlyOperationStatsData ? (
            <p className="pt-2">
              View{' '}
              <Button variant="buttonLink" onClick={handleViewChange}>
                errored requests
              </Button>{' '}
              to see operation error rates.
            </p>
          ) : (
            <p>Try adjusting time range or resetting filters.</p>
          )}
        </>
      }
    />
  );
}
